module.exports = __webpack_public_path__ + "img/GJD-min.ba650da8.png";